import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function ContactSection() {
  const {
    t
  } = useLanguage();
  return <section id="contact" className="py-24 bg-white" data-id="element-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-102">
          <h2 className="text-sm font-bold tracking-widest text-brand-copper uppercase mb-3" data-id="element-103">
            {t('contact.label')}
          </h2>
          <h3 className="text-3xl md:text-4xl font-light text-gray-900 mb-6" data-id="element-104">
            {t('contact.title1')}{' '}
            <span className="font-semibold" data-id="element-105">{t('contact.title2')}</span>
          </h3>
          <p className="text-gray-600" data-id="element-106">{t('contact.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-107">
          {/* Contact Info */}
          <div data-id="element-108">
            <div className="bg-brand-bg rounded-2xl p-8 sm:p-10 border border-gray-100 h-full" data-id="element-109">
              <h4 className="text-2xl font-semibold text-gray-900 mb-8" data-id="element-110">
                Singderm Thailand
              </h4>

              <div className="space-y-8" data-id="element-111">
                <div className="flex items-start" data-id="element-112">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center flex-shrink-0 shadow-sm text-brand-copper" data-id="element-113">
                    <MapPin size={24} data-id="element-114" />
                  </div>
                  <div className="ml-4" data-id="element-115">
                    <h5 className="text-sm font-bold text-gray-900 mb-1" data-id="element-116">
                      {t('contact.address')}
                    </h5>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-117">
                      บริษัท โพล่า กรุ๊ป จำกัด (สำนักงานใหญ่)
                      <br data-id="element-118" />
                      171/1 อาคารปิติการณ์เพลส ชั้นที่ 1
                      <br data-id="element-119" />
                      ห้องเลขที่ 106, 107, 109, 110
                      <br data-id="element-120" />
                      ซอย จรัญสนิทวงศ์ 12 ถนนจรัญสนิทวงศ์
                      <br data-id="element-121" />
                      แขวงวัดท่าพระ เขตบางกอกใหญ่ กรุงเทพมหานคร 10600
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-122">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center flex-shrink-0 shadow-sm text-brand-copper" data-id="element-123">
                    <Phone size={24} data-id="element-124" />
                  </div>
                  <div className="ml-4" data-id="element-125">
                    <h5 className="text-sm font-bold text-gray-900 mb-1" data-id="element-126">
                      {t('contact.phone')}
                    </h5>
                    <p className="text-gray-600 text-sm" data-id="element-127">065-242-5494</p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-128">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center flex-shrink-0 shadow-sm text-brand-copper" data-id="element-129">
                    <Mail size={24} data-id="element-130" />
                  </div>
                  <div className="ml-4" data-id="element-131">
                    <h5 className="text-sm font-bold text-gray-900 mb-1" data-id="element-132">
                      {t('contact.email')}
                    </h5>
                    <p className="text-gray-600 text-sm" data-id="element-133">polamkt01@gmail.com</p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-134">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center flex-shrink-0 shadow-sm text-brand-copper" data-id="element-135">
                    <Clock size={24} data-id="element-136" />
                  </div>
                  <div className="ml-4" data-id="element-137">
                    <h5 className="text-sm font-bold text-gray-900 mb-1" data-id="element-138">
                      {t('contact.hours')}
                    </h5>
                    <p className="text-gray-600 text-sm" data-id="element-139">
                      {t('contact.hoursValue')}
                    </p>
                  </div>
                </div>
              </div>

              {/* Social Media */}
              <div className="mt-10 pt-8 border-t border-gray-200" data-id="element-140">
                <h5 className="text-sm font-bold text-gray-900 mb-4" data-id="element-141">
                  Follow Us
                </h5>
                <div className="grid grid-cols-2 gap-3" data-id="element-142">
                  <a href="https://www.facebook.com/singdermthailand" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center bg-[#1877F2] text-white px-4 py-2.5 rounded-full text-sm font-medium hover:opacity-90 transition-opacity" data-id="element-143">
                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-144">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-145" />
                    </svg>
                    singdermthailand
                  </a>
                  <a href="https://www.instagram.com/singdermthailand" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#F77737] text-white px-4 py-2.5 rounded-full text-sm font-medium hover:opacity-90 transition-opacity" data-id="element-146">
                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-147">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" data-id="element-148" />
                    </svg>
                    singdermthailand
                  </a>
                  <a href="https://www.tiktok.com/@singderm_thailand" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center bg-black text-white px-4 py-2.5 rounded-full text-sm font-medium hover:opacity-90 transition-opacity" data-id="element-149">
                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-150">
                      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" data-id="element-151" />
                    </svg>
                    singderm_thailand
                  </a>
                  <a href="https://line.me/R/ti/p/@singdermthailand" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center bg-[#06C755] text-white px-4 py-2.5 rounded-full text-sm font-medium hover:opacity-90 transition-opacity" data-id="element-152">
                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-153">
                      <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314" data-id="element-154" />
                    </svg>
                    @singdermthailand
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div data-id="element-155">
            <form className="bg-white rounded-2xl p-8 sm:p-10 shadow-card border border-gray-100" data-id="element-156">
              <h4 className="text-2xl font-semibold text-gray-900 mb-6" data-id="element-157">
                {t('contact.formTitle')}
              </h4>

              <div className="space-y-5" data-id="element-158">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-159">
                  <div data-id="element-160">
                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-161">
                      {t('contact.firstName')}
                    </label>
                    <input type="text" id="firstName" className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-brand-copper focus:border-brand-copper outline-none transition-colors" placeholder="John" data-id="element-162" />
                  </div>
                  <div data-id="element-163">
                    <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-164">
                      {t('contact.lastName')}
                    </label>
                    <input type="text" id="lastName" className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-brand-copper focus:border-brand-copper outline-none transition-colors" placeholder="Doe" data-id="element-165" />
                  </div>
                </div>

                <div data-id="element-166">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-167">
                    {t('contact.emailAddress')}
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-brand-copper focus:border-brand-copper outline-none transition-colors" placeholder="john@example.com" data-id="element-168" />
                </div>

                <div data-id="element-169">
                  <label htmlFor="inquiryType" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-170">
                    {t('contact.inquiryType')}
                  </label>
                  <select id="inquiryType" className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-brand-copper focus:border-brand-copper outline-none transition-colors bg-white" data-id="element-171">
                    <option data-id="element-172">{t('contact.productInfo')}</option>
                    <option data-id="element-173">{t('contact.distribution')}</option>
                    <option data-id="element-174">{t('contact.pricing')}</option>
                    <option data-id="element-175">{t('contact.other')}</option>
                  </select>
                </div>

                <div data-id="element-176">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-177">
                    {t('contact.message')}
                  </label>
                  <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-brand-copper focus:border-brand-copper outline-none transition-colors resize-none" placeholder={t('contact.messagePlaceholder')} data-id="element-178"></textarea>
                </div>

                <button type="button" className="w-full bg-brand-copper text-white font-medium py-3 px-4 rounded-md hover:bg-brand-darkCopper transition-colors" data-id="element-179">
                  {t('contact.send')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>;
}